module.exports = __webpack_public_path__ + "static/img/img16.0693745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img16.png
// module id = 3iB9
// module chunks = 1